"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allowanceValidationSchema = void 0;
const yup_1 = require("yup");
const yup_rules_eth_1 = require("@dzambalaorg/yup-rules-eth");
const yup_rules_1 = require("@dzambalaorg/yup-rules");
const types_1 = require("@framework/types");
exports.allowanceValidationSchema = (0, yup_1.object)().shape({
    amount: yup_rules_eth_1.bigNumberValidationSchema
        .typeError("form.validations.badInput")
        .required("form.validations.valueMissing")
        .min(0, "form.validations.rangeUnderflow"),
    contract: (0, yup_1.object)().shape({
        address: yup_rules_eth_1.addressValidationSchema,
        contractType: (0, yup_1.mixed)().oneOf(Object.values(types_1.TokenType)).required("form.validations.valueMissing"),
        decimals: (0, yup_1.number)().required("form.validations.valueMissing"),
    }),
    contractId: yup_rules_1.dbIdValidationSchema,
});
//# sourceMappingURL=validation.js.map